import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { UrlPrefix } from "../common/constants/url-prefix.constants";
import { catchError } from 'rxjs/operators';
import { MessagesService } from '../common/services/messages.service';
import { TranslationService } from '../common/services/translation.service';

@Injectable()
export class FileService {

  constructor(private http: HttpClient,
    private messagesService: MessagesService, 
    private translationService: TranslationService) {
    }

  public getFileNames(url: string): Observable<Array<string>> {
    return this.http.get<Array<string>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}`);
  }

  public downloadFile(url: string, fileName: string): Observable<Blob> {
    const options = {
      headers: {'ignoreExceptionHandling': 'true'},
      params: { id: fileName },
      responseType: 'blob' as 'json'
    };

    return this.http.get<Blob>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}`, options).pipe(
                         catchError(error => { 
                           let contentText;
                           if(error.status == 404){
                            contentText = `${fileName} ${this.translationService.translate('Admin.DownloadFile.FileNotFound')}`;
                            }else {
                              contentText = `${fileName} ${this.translationService.translate('Admin.DownloadFile.Error')}`;
                            }

                           this.messagesService.showAlertDialog({
                            title: this.translationService.translate('Msg.Error'),
                            content: contentText
                          })
                           return throwError(error);
                        })
                      );; 
  }

  public uploadFile(url: string, file: FormData): Observable<any> {
    return this.http.post<any>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}`, file);
  }

  public uploadFileNewSetup(url: string, file: FormData): Observable<any> {
    return this.http.post<any>(`${url}`, file);
  }

  public uploadFileOverwrite(url: string, file: FormData): Observable<any> {
    return this.http.put<any>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}`, file);
  }

  public uploadFileChoice(url: string, file: FormData, overwrite: boolean): Observable<any> {
    if (overwrite === true) {
      return this.uploadFileOverwrite(url, file);
    }
    else {
      return this.uploadFile(url, file);
    }
  }

  public deleteFile(url: string, fileName: string): Observable<void> {
    return this.http.delete<void>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}`, { params: { id: fileName } });
  }

  public downloadXml(url: string) {
    return this.http.get(`${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}`, { responseType: 'text' });
  }

  public downloadXmlNew(url: string) {
    return this.http.get(`api/providers/v1/${url}`, { responseType: 'text' });
  }


  /**
  * Example filePath = 'C:\mydir\myfile.xlsx' -> getFileNameFromPath(filePath)
  * Result: myfile.xlsx
  * Returns the file name and extension of the specified path string.
  * @param filePath The path string from which to obtain the file name and extension.
  */
  public getFileNameFromPath(filePath: string) {
    return filePath.replace(/^.*[\\\/]/, '');
  }
}